export default "__VITE_ASSET__CmAdzdNO__"